import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const GaugeChart = ({ value = 0.0 }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const resizeObserver = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    // Initialize chart
    chartInstance.current = echarts.init(chartRef.current);

    const getOption = (val) => ({
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          center: ["50%", "75%"],
          radius: "90%",
          min: 0,
          max: 1,
          splitNumber: 8,
          axisLine: {
            lineStyle: {
              width: 6,
              color: [
                [0.25, "#FF6E76"],
                [0.5, "#FDDD60"],
                [0.75, "#58D9F9"],
                [1, "#7CFFB2"],
              ],
            },
          },
          pointer: {
            icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
            length: "12%",
            width: 20,
            offsetCenter: [0, "-60%"],
            itemStyle: { color: "auto" },
          },
          axisTick: { length: 12, lineStyle: { color: "auto", width: 2 } },
          splitLine: { length: 20, lineStyle: { color: "auto", width: 5 } },
          axisLabel: {
            color: "#464646",
            fontSize: 12,
            distance: -50,
            rotate: "tangential",
            formatter: (v) => {
              if (v === 0.875) return "Grade A";
              if (v === 0.625) return "Grade B";
              if (v === 0.375) return "Grade C";
              if (v === 0.125) return "Grade D";
              return "";
            },
          },
          detail: {
            valueAnimation: true,
            offsetCenter: [0, "-20%"], // position slightly above center
            // formatter: (v) => `{val|${Math.round(v * 100).toFixed(2)}%}\n{name|Grade Rating}`,
            formatter: (v) => `{val|${(v * 100).toFixed(2)}%}\n{name|Grade Rating}`,
            rich: {
              val: { fontSize: 22, fontWeight: "bold", color: "inherit" },
              name: { fontSize: 12, color: "#464646" },
            },
          },
          data: [{ value: val }],
        },
      ],
    });

    chartInstance.current.setOption(getOption(value));

    // ResizeObserver for responsive parent
    resizeObserver.current = new ResizeObserver(() => {
      chartInstance.current?.resize();
    });
    resizeObserver.current.observe(chartRef.current);

    // Cleanup
    return () => {
      resizeObserver.current?.disconnect();
      chartInstance.current?.dispose();
    };
  }, []);

  // Update only value on prop change
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.setOption({
        series: [{ data: [{ value }] }],
      });
    }
  }, [value]);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "100%",
        minHeight: "250px",
      }}
    />
  );
};

export default GaugeChart;